import React from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Container } from "reactstrap"
import PotentialLeads from "./PotentialLeads"

const OpportunityLeads = ({ junk = false }) => {
    return (
        <div>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title={"Sales"} breadcrumbItem={`${junk ? 'Junk Leads' : 'Opportunity Leads'}`} />
                    <PotentialLeads junk={junk} />
                </Container>
            </div>
        </div>
    )
}

export default OpportunityLeads
